"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isCorrectColor = void 0;
/**
 * Checks if `color` is key of `palette`.
 * @param palette Is `theme.palette` object.
 * @param color Is possible key of `palette`.
 * @returns True if `color` is key of `palette`.
 */ var isCorrectColor = function(palette, color) {
    return Object.keys(palette).includes(color);
};
exports.isCorrectColor = isCorrectColor; //# sourceMappingURL=isCorrectColor.js.map
